// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//   Container, Row, Col, Card, Button, Form,
//   Alert, Spinner, Modal, InputGroup, Badge, OverlayTrigger, Tooltip
// } from 'react-bootstrap';
// import {
//   FaPlus, FaEdit, FaTrash, FaFilter, FaSave, FaTimes,
//   FaMoneyBillWave, FaArrowUp, FaArrowDown, FaCheck,
//   FaExclamationTriangle, FaCalendarAlt, FaSort, FaSortUp,
//   FaSortDown, FaDownload, FaEye, FaUndo, FaClock, FaSearch
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { PageHeader }   from '../../components/shared/PageHeader';
// import { DataTable }    from '../../components/shared/DataTable';
// import { ConfirmModal } from '../../components/shared/ConfirmModal';
// import { StatusSwitch } from '../../components/shared/StatusSwitch';

// // ── Constantes ──
// const TIPOS  = { RECEBER: 'receber', PAGAR: 'pagar' };
// const STATUS = { PENDENTE: 'pendente', PAGO: 'pago', ATRASADO: 'atrasado' };

// const MESES = [
//   { value: '1', label: 'Janeiro' }, { value: '2', label: 'Fevereiro' },
//   { value: '3', label: 'Março'   }, { value: '4', label: 'Abril'     },
//   { value: '5', label: 'Maio'    }, { value: '6', label: 'Junho'     },
//   { value: '7', label: 'Julho'   }, { value: '8', label: 'Agosto'    },
//   { value: '9', label: 'Setembro'}, { value: '10',label: 'Outubro'   },
//   { value: '11',label: 'Novembro'}, { value: '12',label: 'Dezembro'  },
// ];

// const gerarAnos = () => {
//   const a = new Date().getFullYear();
//   return Array.from({ length: 5 }, (_, i) => a - 2 + i);
// };

// // ── Utils ──
// const formatCurrency = (v) =>
//   typeof v === 'number' && !isNaN(v)
//     ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
//     : 'R$ 0,00';

// const formatDate = (s) => {
//   if (!s) return '-';
//   try {
//     const [y, m, d] = s.split('T')[0].split('-');
//     return `${d}/${m}/${y}`;
//   } catch { return '-'; }
// };

// const isOverdue = (dataVenc, status) => {
//   if (status === STATUS.PAGO || !dataVenc) return false;
//   return new Date(dataVenc) < new Date();
// };

// const useDebounce = (value, delay) => {
//   const [dv, setDv] = useState(value);
//   useEffect(() => {
//     const h = setTimeout(() => setDv(value), delay);
//     return () => clearTimeout(h);
//   }, [value, delay]);
//   return dv;
// };

// const COLUMNS = ['Descrição', 'Categoria', 'Tipo', 'Valor', 'Vencimento', 'Status', 'Cliente', 'Ações'];

// // ==========================================
// export default function Contas() {
//   const anoAtual = new Date().getFullYear();
//   const mesAtual = String(new Date().getMonth() + 1);

//   const [contas,           setContas]           = useState([]);
//   const [searchTerm,       setSearchTerm]       = useState('');
//   const [filterTipo,       setFilterTipo]       = useState('todos');
//   const [filterStatus,     setFilterStatus]     = useState('todos');
//   const [filterCategoria,  setFilterCategoria]  = useState('todas');
//   const [tipoPeriodo,      setTipoPeriodo]      = useState('mes');
//   const [filterMes,        setFilterMes]        = useState(mesAtual);
//   const [filterAno,        setFilterAno]        = useState(String(anoAtual));
//   const [filterDataInicio, setFilterDataInicio] = useState('');
//   const [filterDataFim,    setFilterDataFim]    = useState('');
//   const [loading,          setLoading]          = useState(true);
//   const [error,            setError]            = useState('');
//   const [sortConfig,       setSortConfig]       = useState({ key: null, direction: 'asc' });

//   // Modais
//   const [showModal,        setShowModal]        = useState(false);
//   const [currentConta,     setCurrentConta]     = useState(null);
//   const [showDeleteModal,  setShowDeleteModal]  = useState(false);
//   const [contaToDelete,    setContaToDelete]    = useState(null);
//   const [showPayModal,     setShowPayModal]     = useState(false);
//   const [contaToPay,       setContaToPay]       = useState(null);

//   const debouncedSearch = useDebounce(searchTerm, 300);

//   // ── Fetch ──
//   const fetchData = useCallback(async () => {
//     try {
//       setLoading(true); setError('');
//       const res = await api.get('/financial-records');
//       setContas(res.data.map(c => ({
//         ...c,
//         status: isOverdue(c.dataVencimento, c.status) ? STATUS.ATRASADO : c.status,
//       })));
//     } catch {
//       setError('Erro ao carregar contas do banco de dados.');
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const categoriasUnicas = useMemo(() =>
//     [...new Set(contas.map(c => c.categoria).filter(Boolean))].sort()
//   , [contas]);

//   // ── Handlers ──
//   const handleSave = useCallback(async (data) => {
//     try {
//       if (data.id) {
//         await api.put(`/financial-records/${data.id}`, data);
//         toast.success('Conta atualizada!');
//       } else {
//         await api.post('/financial-records', data);
//         toast.success('Conta criada!');
//       }
//       fetchData();
//       setShowModal(false);
//       setCurrentConta(null);
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao salvar a conta.');
//     }
//   }, [fetchData]);

//   const handleDelete = useCallback(async () => {
//     if (!contaToDelete) return;
//     try {
//       await api.delete(`/financial-records/${contaToDelete.id}`);
//       toast.success('Conta excluída!');
//       setContas(prev => prev.filter(c => c.id !== contaToDelete.id));
//       setShowDeleteModal(false);
//       setContaToDelete(null);
//     } catch {
//       toast.error('Erro ao excluir conta.');
//     }
//   }, [contaToDelete]);

//   const handleTogglePay = useCallback(async (markAsPaid = true) => {
//     if (!contaToPay) return;
//     try {
//       setShowPayModal(false);
//       if (contaToPay.isParcela) {
//         await api.put(`/financial/installments/${contaToPay.id}`, {
//           status: markAsPaid ? 'PAID' : 'PENDING',
//           paidAt: markAsPaid ? new Date().toISOString() : null,
//         });
//       } else {
//         await api.put(`/financial-records/${contaToPay.id}`, {
//           ...contaToPay,
//           status:        markAsPaid ? STATUS.PAGO    : STATUS.PENDENTE,
//           dataPagamento: markAsPaid ? new Date().toISOString().split('T')[0] : '',
//         });
//       }
//       toast.success(markAsPaid ? 'Marcado como pago!' : 'Marcado como pendente!');
//       fetchData();
//       setContaToPay(null);
//     } catch {
//       toast.error('Erro ao alterar status de pagamento.');
//     }
//   }, [contaToPay, fetchData]);

//   const handleEdit = useCallback((conta) => {
//     if (conta.isParcela) {
//       setError('Edição não disponível para parcelas de pedidos.');
//       return;
//     }
//     setCurrentConta(conta);
//     setShowModal(true);
//   }, []);

//   const confirmDelete = useCallback((conta) => {
//     if (conta.isParcela) {
//       setError('Não é permitido excluir parcelas de pedidos.');
//       return;
//     }
//     setContaToDelete(conta);
//     setShowDeleteModal(true);
//   }, []);

//   const limparFiltros = () => {
//     setSearchTerm(''); setFilterTipo('todos'); setFilterStatus('todos');
//     setFilterCategoria('todas'); setTipoPeriodo('mes');
//     setFilterMes(mesAtual); setFilterAno(String(anoAtual));
//     setFilterDataInicio(''); setFilterDataFim('');
//   };

//   // ── Filtro + Ordenação ──
//   const filteredContas = useMemo(() => {
//     let list = contas;

//     if (filterTipo !== 'todos')     list = list.filter(c => c.tipo === filterTipo);
//     if (filterStatus !== 'todos')   list = list.filter(c => c.status === filterStatus);
//     if (filterCategoria !== 'todas')list = list.filter(c => c.categoria === filterCategoria);

//     if (tipoPeriodo === 'mes' && filterMes && filterAno) {
//       list = list.filter(c => {
//         if (!c.dataVencimento) return false;
//         const d = new Date(c.dataVencimento);
//         return d.getMonth() + 1 === parseInt(filterMes) && d.getFullYear() === parseInt(filterAno);
//       });
//     }
//     if (tipoPeriodo === 'periodo') {
//       if (filterDataInicio) list = list.filter(c => c.dataVencimento && new Date(c.dataVencimento) >= new Date(filterDataInicio));
//       if (filterDataFim)    list = list.filter(c => c.dataVencimento && new Date(c.dataVencimento) <= new Date(filterDataFim));
//     }

//     if (debouncedSearch.trim()) {
//       const t = debouncedSearch.toLowerCase();
//       list = list.filter(c =>
//         (c.descricao   || '').toLowerCase().includes(t) ||
//         (c.categoria   || '').toLowerCase().includes(t) ||
//         (c.clienteNome || '').toLowerCase().includes(t)
//       );
//     }

//     if (sortConfig.key) {
//       list = [...list].sort((a, b) => {
//         let av = a[sortConfig.key], bv = b[sortConfig.key];
//         if (sortConfig.key === 'valor') { av = Number(av) || 0; bv = Number(bv) || 0; }
//         if (['dataVencimento','dataPagamento'].includes(sortConfig.key)) {
//           av = av ? new Date(av) : new Date(0);
//           bv = bv ? new Date(bv) : new Date(0);
//         }
//         if (av < bv) return sortConfig.direction === 'asc' ? -1 : 1;
//         if (av > bv) return sortConfig.direction === 'asc' ?  1 : -1;
//         return 0;
//       });
//     }
//     return list;
//   }, [contas, filterTipo, filterStatus, filterCategoria, tipoPeriodo, filterMes, filterAno, filterDataInicio, filterDataFim, debouncedSearch, sortConfig]);

//   // ── Totais ──
//   const totals = useMemo(() => ({
//     totalReceber:  filteredContas.filter(c => c.tipo === TIPOS.RECEBER && c.status !== STATUS.PAGO).reduce((s, c) => s + (c.valor || 0), 0),
//     totalPagar:    filteredContas.filter(c => c.tipo === TIPOS.PAGAR   && c.status !== STATUS.PAGO).reduce((s, c) => s + (c.valor || 0), 0),
//     totalAtrasado: filteredContas.filter(c => c.status === STATUS.ATRASADO).reduce((s, c) => s + (c.valor || 0), 0),
//   }), [filteredContas]);

//   const handleSort = (key) => setSortConfig(prev => ({
//     key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//   }));

//   const SortIcon = ({ col }) => {
//     if (sortConfig.key !== col) return <FaSort className="ms-1 text-muted" />;
//     return sortConfig.direction === 'asc' ? <FaSortUp className="ms-1" /> : <FaSortDown className="ms-1" />;
//   };

//   const StatusBadge = ({ status }) => {
//     const map = {
//       [STATUS.PAGO]:     { bg: 'success', text: 'Pago'     },
//       [STATUS.ATRASADO]: { bg: 'danger',  text: 'Atrasado' },
//       [STATUS.PENDENTE]: { bg: 'warning', text: 'Pendente' },
//     };
//     const c = map[status] || map[STATUS.PENDENTE];
//     return <p bg={c.bg}>{c.text}</p>;
//   };

//   const TipoBadge = ({ tipo }) => (
//     tipo === TIPOS.RECEBER
//       ? <p bg="success"><FaArrowDown className="me-1" size={10} />A Receber</p>
//       : <p bg="danger"><FaArrowUp className="me-1" size={10} />A Pagar</p>
//   );

//   const exportCSV = () => {
//     const rows = [
//       ['Descrição','Categoria','Tipo','Valor','Vencimento','Status','Pagamento','Cliente'].join(','),
//       ...filteredContas.map(c => [
//         `"${c.descricao}"`, `"${c.categoria}"`,
//         c.tipo === TIPOS.RECEBER ? 'A Receber' : 'A Pagar',
//         c.valor, formatDate(c.dataVencimento),
//         c.status === STATUS.PAGO ? 'Pago' : c.status === STATUS.ATRASADO ? 'Atrasado' : 'Pendente',
//         formatDate(c.dataPagamento), `"${c.clienteNome || '-'}"`
//       ].join(','))
//     ].join('\n');
//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(new Blob([rows], { type: 'text/csv;charset=utf-8;' }));
//     a.download = `contas_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//   };

//   const labelPeriodo = useMemo(() => {
//     if (tipoPeriodo === 'mes') return `${MESES.find(m => m.value === filterMes)?.label || ''} / ${filterAno}`;
//     if (tipoPeriodo === 'periodo' && (filterDataInicio || filterDataFim))
//       return `${filterDataInicio ? formatDate(filterDataInicio) : '...'} até ${filterDataFim ? formatDate(filterDataFim) : '...'}`;
//     return 'Todos os períodos';
//   }, [tipoPeriodo, filterMes, filterAno, filterDataInicio, filterDataFim]);

//   return (
//     <Container fluid className="p-4">

//       <PageHeader
//         title="Contas a Pagar e Receber"
//         subtitle={<><FaCalendarAlt className="me-1" />{labelPeriodo}</>}
//         buttonLabel="Nova Conta"
//         onButtonClick={() => { setCurrentConta(null); setShowModal(true); }}
//       >
//         <Button variant="outline-secondary" onClick={exportCSV} disabled={filteredContas.length === 0} className="me-2">
//           <FaDownload className="me-2" />Exportar CSV
//         </Button>
//       </PageHeader>

//       {error && <Alert variant="danger" dismissible onClose={() => setError('')}><FaExclamationTriangle className="me-2" />{error}</Alert>}

//       {/* ── Cards KPI ── */}
//       <Row className="mb-4">
//         {[
//           { label: 'A Receber',      value: totals.totalReceber,                        color: 'success', Icon: FaArrowDown   },
//           { label: 'A Pagar',        value: totals.totalPagar,                          color: 'danger',  Icon: FaArrowUp     },
//           { label: 'Em Atraso',      value: totals.totalAtrasado,                       color: 'warning', Icon: FaCalendarAlt },
//           { label: 'Saldo Previsto', value: totals.totalReceber - totals.totalPagar,
//             color: totals.totalReceber - totals.totalPagar >= 0 ? 'success' : 'danger', Icon: FaMoneyBillWave },
//         ].map(({ label, value, color, Icon }) => (
//           <Col lg={3} md={6} className="mb-3" key={label}>
//             <Card className="h-100 shadow-sm">
//               <Card.Body className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <div className="text-muted small">{label}</div>
//                   <h4 className={`mb-0 text-${color}`}>{formatCurrency(value)}</h4>
//                 </div>
//                 <div className={`bg-${color} bg-opacity-10 p-3 rounded-circle`}>
//                   <Icon className={`text-${color}`} size={20} />
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* ── Filtros ── */}
//       <Card className="mb-4 shadow-sm">
//         <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
//           <span className="fw-semibold"><FaFilter className="me-2" />Filtros</span>
//           <Button variant="link" size="sm" className="text-muted p-0 text-decoration-none" onClick={limparFiltros}>
//             <FaTimes className="me-1" />Limpar filtros
//           </Button>
//         </Card.Header>
//         <Card.Body>
//           <Row className="mb-3 g-2">
//             <Col lg={4}>
//               <InputGroup>
//                 <InputGroup.Text><FaSearch /></InputGroup.Text>
//                 <Form.Control placeholder="Buscar por descrição, categoria ou cliente..."
//                   value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//               </InputGroup>
//             </Col>
//             <Col lg={2} md={4}>
//               <Form.Select value={filterTipo} onChange={e => setFilterTipo(e.target.value)}>
//                 <option value="todos">Todos os Tipos</option>
//                 <option value={TIPOS.RECEBER}>A Receber</option>
//                 <option value={TIPOS.PAGAR}>A Pagar</option>
//               </Form.Select>
//             </Col>
//             <Col lg={2} md={4}>
//               <Form.Select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
//                 <option value="todos">Todos os Status</option>
//                 <option value={STATUS.PENDENTE}>Pendente</option>
//                 <option value={STATUS.PAGO}>Pago</option>
//                 <option value={STATUS.ATRASADO}>Atrasado</option>
//               </Form.Select>
//             </Col>
//             <Col lg={4} md={4}>
//               <Form.Select value={filterCategoria} onChange={e => setFilterCategoria(e.target.value)}>
//                 <option value="todas">Todas as Categorias</option>
//                 {categoriasUnicas.map(c => <option key={c} value={c}>{c}</option>)}
//               </Form.Select>
//             </Col>
//           </Row>

//           <Row className="align-items-end g-2">
//             <Col lg={3}>
//               <Form.Label className="small text-muted mb-1">Filtrar por período</Form.Label>
//               <div className="d-flex gap-1">
//                 {[{ value:'mes',label:'Mês/Ano'},{value:'periodo',label:'Intervalo'},{value:'todos',label:'Todos'}].map(op => (
//                   <Button key={op.value} size="sm" className="flex-fill"
//                     variant={tipoPeriodo === op.value ? 'primary' : 'outline-secondary'}
//                     onClick={() => setTipoPeriodo(op.value)}>
//                     {op.label}
//                   </Button>
//                 ))}
//               </div>
//             </Col>
//             {tipoPeriodo === 'mes' && <>
//               <Col lg={2} md={6}>
//                 <Form.Label className="small text-muted mb-1">Mês</Form.Label>
//                 <Form.Select value={filterMes} onChange={e => setFilterMes(e.target.value)}>
//                   {MESES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
//                 </Form.Select>
//               </Col>
//               <Col lg={2} md={6}>
//                 <Form.Label className="small text-muted mb-1">Ano</Form.Label>
//                 <Form.Select value={filterAno} onChange={e => setFilterAno(e.target.value)}>
//                   {gerarAnos().map(a => <option key={a} value={String(a)}>{a}</option>)}
//                 </Form.Select>
//               </Col>
//             </>}
//             {tipoPeriodo === 'periodo' && <>
//               <Col lg={2} md={6}>
//                 <Form.Label className="small text-muted mb-1">Data Início</Form.Label>
//                 <Form.Control type="date" value={filterDataInicio} onChange={e => setFilterDataInicio(e.target.value)} />
//               </Col>
//               <Col lg={2} md={6}>
//                 <Form.Label className="small text-muted mb-1">Data Fim</Form.Label>
//                 <Form.Control type="date" value={filterDataFim} min={filterDataInicio} onChange={e => setFilterDataFim(e.target.value)} />
//               </Col>
//             </>}
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* ── Tabela ── */}
//       {loading ? (
//         <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>
//       ) : (
//         <Card className="shadow-sm">
//           <Card.Body>
//             <p className="text-muted mb-3">{filteredContas.length} conta(s) — {labelPeriodo}</p>
//             <div className="table-responsive">
//               <table className="table table-hover">
//                 <thead>
//                   <tr>
//                     {[
//                       ['descricao','Descrição'],['categoria','Categoria'],['tipo','Tipo'],
//                       ['valor','Valor'],['dataVencimento','Vencimento'],['status','Status'],
//                       ['clienteNome','Cliente'],
//                     ].map(([key, label]) => (
//                       <th key={key} style={{ cursor:'pointer' }} onClick={() => handleSort(key)}>
//                         {label} <SortIcon col={key} />
//                       </th>
//                     ))}
//                     <th className="text-end">Ações</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredContas.map(conta => (
//                     <tr key={conta.id}>
//                       <td>
//                         {conta.descricao}
//                         {conta.isParcela && <><br /><small className="text-muted">Parcela de pedido</small></>}
//                       </td>
//                       <td>{conta.categoria}</td>
//                       <td><TipoBadge tipo={conta.tipo} /></td>
//                       <td className="fw-bold">{formatCurrency(conta.valor)}</td>
//                       <td>
//                         {formatDate(conta.dataVencimento)}
//                         {conta.dataPagamento && conta.status === STATUS.PAGO && (
//                           <><br /><small className="text-muted">Pago: {formatDate(conta.dataPagamento)}</small></>
//                         )}
//                       </td>
//                       <td><StatusBadge status={conta.status} /></td>
//                       <td>{conta.clienteNome || '-'}</td>
//                       <td className="text-end">
//                         <div className="d-flex justify-content-end gap-1">
//                           <OverlayTrigger placement="top" overlay={<Tooltip>{conta.status === STATUS.PAGO ? 'Marcar pendente' : 'Marcar pago'}</Tooltip>}>
//                             <Button size="sm"
//                               variant={conta.status === STATUS.PAGO ? 'outline-warning' : 'outline-success'}
//                               onClick={() => { setContaToPay(conta); setShowPayModal(true); }}>
//                               {conta.status === STATUS.PAGO ? <FaUndo /> : <FaCheck />}
//                             </Button>
//                           </OverlayTrigger>
//                           <OverlayTrigger placement="top" overlay={<Tooltip>{conta.isParcela ? 'Não editável' : 'Editar'}</Tooltip>}>
//                             <span className="d-inline-block">
//                               <Button size="sm" variant="outline-primary"
//                                 onClick={() => handleEdit(conta)} disabled={conta.isParcela}>
//                                 <FaEdit />
//                               </Button>
//                             </span>
//                           </OverlayTrigger>
//                           <OverlayTrigger placement="top" overlay={<Tooltip>{conta.isParcela ? 'Não excluível' : 'Excluir'}</Tooltip>}>
//                             <span className="d-inline-block">
//                               <Button size="sm" variant="outline-danger"
//                                 onClick={() => confirmDelete(conta)} disabled={conta.isParcela}>
//                                 <FaTrash />
//                               </Button>
//                             </span>
//                           </OverlayTrigger>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                   {filteredContas.length === 0 && (
//                     <tr>
//                       <td colSpan={8} className="text-center py-5">
//                         <FaEye size={40} className="mb-2 opacity-25 d-block mx-auto" />
//                         <p className="text-muted mb-0">Nenhuma conta encontrada</p>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* ── Modal Novo/Editar ── */}
//       <Modal show={showModal} onHide={() => { setShowModal(false); setCurrentConta(null); }} size="lg">
//         <Modal.Body className="p-0">
//           <ContaForm conta={currentConta} onSave={handleSave}
//             onCancel={() => { setShowModal(false); setCurrentConta(null); }} />
//         </Modal.Body>
//       </Modal>

//       {/* ── Modal Pagamento ── */}
//       <ConfirmModal
//         show={showPayModal}
//         onHide={() => setShowPayModal(false)}
//         onConfirm={() => handleTogglePay(contaToPay?.status !== STATUS.PAGO)}
//         title="Confirmar Alteração"
//         message={<>Deseja alterar o status de: <strong>"{contaToPay?.descricao}"</strong>?</>}
//         confirmLabel={contaToPay?.status === STATUS.PAGO ? 'Marcar como Pendente' : 'Marcar como Pago'}
//         confirmVariant={contaToPay?.status === STATUS.PAGO ? 'warning' : 'success'}
//         icon={FaClock}
//         iconColor="text-primary"
//       />

//       {/* ── Modal Exclusão ── */}
//       <ConfirmModal
//         show={showDeleteModal}
//         onHide={() => setShowDeleteModal(false)}
//         onConfirm={handleDelete}
//         title="Confirmar Exclusão"
//         message={<>Tem certeza que deseja excluir: <strong>"{contaToDelete?.descricao}"</strong>?</>}
//         confirmLabel="Excluir"
//         confirmVariant="danger"
//       />

//     </Container>
//   );
// }

// // ==========================================
// // FORMULÁRIO
// // ==========================================
// function ContaForm({ conta, onSave, onCancel }) {
//   const [formData, setFormData] = useState({
//     id:             conta?.id             || null,
//     tipo:           conta?.tipo           || TIPOS.PAGAR,
//     descricao:      conta?.descricao      || '',
//     valor:          conta?.valor          || '',
//     dataVencimento: conta?.dataVencimento ? conta.dataVencimento.split('T')[0] : '',
//     dataPagamento:  conta?.dataPagamento  ? conta.dataPagamento.split('T')[0]  : '',
//     status:         conta?.status         || STATUS.PENDENTE,
//     categoria:      conta?.categoria      || '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const isPagar = formData.tipo === TIPOS.PAGAR;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.descricao.trim() || !formData.valor) return;
//     setIsSubmitting(true);
//     await onSave(formData);
//     setIsSubmitting(false);
//   };

//   return (
//     <Card className="border-0 mb-0">
//       {/* <Card.Header className="bg-white d-flex justify-content-between align-items-center py-3">
//         <h5 className="mb-0">{conta ? 'Editar Conta' : 'Nova Conta'}</h5>
//         <div className="d-flex align-items-center gap-2">
//           <span className="small text-success fw-bold">A Receber</span>
//           <StatusSwitch
//             value={!isPagar}
//             onChange={(v) => setFormData(prev => ({ ...prev, tipo: v ? TIPOS.RECEBER : TIPOS.PAGAR }))}
//             colorOn="#198754"
//             colorOff="#dc3545"
//             labelOn=""
//             labelOff=""
//           />
//           <span className="small text-danger fw-bold">A Pagar</span>
//         </div>
//       </Card.Header> */}

//       <Card.Header className="bg-white d-flex justify-content-between align-items-center py-3">
//   <h5 className="mb-0">{conta ? 'Editar Conta' : 'Nova Conta'}</h5>

//   <div className="btn-group" role="group">
//     <Button
//       size="sm"
//       variant={isPagar ? 'danger' : 'outline-danger'}
//       onClick={() => setFormData(prev => ({ ...prev, tipo: TIPOS.PAGAR }))}
//     >
//       <FaArrowUp className="me-1" size={10} />
//       A Pagar
//     </Button>
//     <Button
//       size="sm"
//       variant={!isPagar ? 'success' : 'outline-success'}
//       onClick={() => setFormData(prev => ({ ...prev, tipo: TIPOS.RECEBER }))}
//     >
//       <FaArrowDown className="me-1" size={10} />
//       A Receber
//     </Button>
//   </div>
// </Card.Header>


//       <Card.Body className="p-4">
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             <Col md={8}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Descrição *</Form.Label>
//                 <Form.Control name="descricao" value={formData.descricao} onChange={handleChange} required
//                   placeholder="Ex: Pagamento de aluguel..." />
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Categoria *</Form.Label>
//                 <Form.Control name="categoria" value={formData.categoria} onChange={handleChange} required
//                   placeholder="Ex: Aluguel, Impostos..." />
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Valor *</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>R$</InputGroup.Text>
//                   <Form.Control type="number" name="valor" value={formData.valor}
//                     onChange={handleChange} required min="0.01" step="0.01" placeholder="0,00" />
//                 </InputGroup>
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Data de Vencimento *</Form.Label>
//                 <Form.Control type="date" name="dataVencimento" value={formData.dataVencimento}
//                   onChange={handleChange} required />
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Status</Form.Label>
//                 <div className="d-flex align-items-center gap-2 mt-1">
//                   <StatusSwitch
//                     value={formData.status === STATUS.PAGO}
//                     onChange={(v) => setFormData(prev => ({
//                       ...prev,
//                       status: v ? STATUS.PAGO : STATUS.PENDENTE,
//                       dataPagamento: v ? new Date().toISOString().split('T')[0] : '',
//                     }))}
//                     labelOn="Pago"
//                     labelOff="Pendente"
//                   />
//                 </div>
//               </Form.Group>
//             </Col>
//           </Row>

//           {formData.status === STATUS.PAGO && (
//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Data de Pagamento *</Form.Label>
//                   <Form.Control type="date" name="dataPagamento" value={formData.dataPagamento}
//                     onChange={handleChange} required />
//                 </Form.Group>
//               </Col>
//             </Row>
//           )}

//           <hr />
//           <div className="d-flex justify-content-end gap-2 mt-3">
//             <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
//               <FaTimes className="me-1" />Cancelar
//             </Button>
//             <Button variant="success" type="submit" disabled={isSubmitting}>
//               {isSubmitting ? <Spinner animation="border" size="sm" /> : <><FaSave className="me-2" />Salvar</>}
//             </Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// }


import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  Container, Row, Col, Card, Button, Form,
  Alert, Spinner, Modal, InputGroup, OverlayTrigger, Tooltip
} from 'react-bootstrap';
import {
  FaPlus, FaEdit, FaTrash, FaFilter, FaSave, FaTimes,
  FaMoneyBillWave, FaArrowUp, FaArrowDown, FaCheck,
  FaExclamationTriangle, FaCalendarAlt, FaSort, FaSortUp,
  FaSortDown, FaDownload, FaEye, FaUndo, FaClock, FaSearch
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';

import { PageHeader }   from '../../components/shared/PageHeader';
import { ConfirmModal } from '../../components/shared/ConfirmModal';
import { StatusSwitch } from '../../components/shared/StatusSwitch';

// ── Constantes ──
const TIPOS  = { RECEBER: 'receber', PAGAR: 'pagar' };
const STATUS = { PENDENTE: 'pendente', PAGO: 'pago', ATRASADO: 'atrasado' };

const MESES = [
  { value: '1', label: 'Janeiro' }, { value: '2', label: 'Fevereiro' },
  { value: '3', label: 'Março'   }, { value: '4', label: 'Abril'     },
  { value: '5', label: 'Maio'    }, { value: '6', label: 'Junho'     },
  { value: '7', label: 'Julho'   }, { value: '8', label: 'Agosto'    },
  { value: '9', label: 'Setembro'}, { value: '10',label: 'Outubro'   },
  { value: '11',label: 'Novembro'}, { value: '12',label: 'Dezembro'  },
];

const gerarAnos = () => {
  const a = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, i) => a - 2 + i);
};

// ── Utils ──
const formatCurrency = (v) =>
  typeof v === 'number' && !isNaN(v)
    ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : 'R$ 0,00';

const formatDate = (s) => {
  if (!s) return '-';
  try {
    const [y, m, d] = s.split('T')[0].split('-');
    return `${d}/${m}/${y}`;
  } catch { return '-'; }
};

const isOverdue = (dataVenc, status) => {
  if (status === STATUS.PAGO || !dataVenc) return false;
  return new Date(dataVenc) < new Date();
};

const useDebounce = (value, delay) => {
  const [dv, setDv] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDv(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return dv;
};

// ── Pílula custom (sem Badge) ──
const Pilula = ({ children, color = '#6c757d', icon: Icon }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '3px 9px',
      borderRadius: 12,
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1.4,
      backgroundColor: `${color}1f`, // ~12% opacity
      color: color,
      border: `1px solid ${color}40`,
      whiteSpace: 'nowrap',
    }}
  >
    {Icon && <Icon size={9} />}
    {children}
  </span>
);

// ==========================================
export default function Contas() {
  const anoAtual = new Date().getFullYear();
  const mesAtual = String(new Date().getMonth() + 1);

  const [contas,           setContas]           = useState([]);
  const [searchTerm,       setSearchTerm]       = useState('');
  const [filterTipo,       setFilterTipo]       = useState('todos');
  const [filterStatus,     setFilterStatus]     = useState('todos');
  const [filterCategoria,  setFilterCategoria]  = useState('todas');
  const [tipoPeriodo,      setTipoPeriodo]      = useState('mes');
  const [filterMes,        setFilterMes]        = useState(mesAtual);
  const [filterAno,        setFilterAno]        = useState(String(anoAtual));
  const [filterDataInicio, setFilterDataInicio] = useState('');
  const [filterDataFim,    setFilterDataFim]    = useState('');
  const [campoData,        setCampoData]        = useState('dataVencimento'); // 🆕
  const [loading,          setLoading]          = useState(true);
  const [error,            setError]            = useState('');
  const [sortConfig,       setSortConfig]       = useState({ key: null, direction: 'asc' });

  // Modais
  const [showModal,        setShowModal]        = useState(false);
  const [currentConta,     setCurrentConta]     = useState(null);
  const [showDeleteModal,  setShowDeleteModal]  = useState(false);
  const [contaToDelete,    setContaToDelete]    = useState(null);
  const [showPayModal,     setShowPayModal]     = useState(false);
  const [contaToPay,       setContaToPay]       = useState(null);

  const debouncedSearch = useDebounce(searchTerm, 300);

  // ── Fetch ──
  const fetchData = useCallback(async () => {
    try {
      setLoading(true); setError('');
      const res = await api.get('/financial-records');
      setContas(res.data.map(c => ({
        ...c,
        status: isOverdue(c.dataVencimento, c.status) ? STATUS.ATRASADO : c.status,
      })));
    } catch {
      setError('Erro ao carregar contas do banco de dados.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const categoriasUnicas = useMemo(() =>
    [...new Set(contas.map(c => c.categoria).filter(Boolean))].sort()
  , [contas]);

  // ── Handlers ──
  const handleSave = useCallback(async (data) => {
    try {
      if (data.id) {
        await api.put(`/financial-records/${data.id}`, data);
        toast.success('Conta atualizada!');
      } else {
        await api.post('/financial-records', data);
        toast.success('Conta criada!');
      }
      fetchData();
      setShowModal(false);
      setCurrentConta(null);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao salvar a conta.');
    }
  }, [fetchData]);

  const handleDelete = useCallback(async () => {
    if (!contaToDelete) return;
    try {
      await api.delete(`/financial-records/${contaToDelete.id}`);
      toast.success('Conta excluída!');
      setContas(prev => prev.filter(c => c.id !== contaToDelete.id));
      setShowDeleteModal(false);
      setContaToDelete(null);
    } catch {
      toast.error('Erro ao excluir conta.');
    }
  }, [contaToDelete]);

  const handleTogglePay = useCallback(async (markAsPaid = true) => {
    if (!contaToPay) return;
    try {
      setShowPayModal(false);
      if (contaToPay.isParcela) {
        await api.put(`/financial/installments/${contaToPay.id}`, {
          status: markAsPaid ? 'PAID' : 'PENDING',
          paidAt: markAsPaid ? new Date().toISOString() : null,
        });
      } else {
        await api.put(`/financial-records/${contaToPay.id}`, {
          ...contaToPay,
          status:        markAsPaid ? STATUS.PAGO    : STATUS.PENDENTE,
          dataPagamento: markAsPaid ? new Date().toISOString().split('T')[0] : '',
        });
      }
      toast.success(markAsPaid ? 'Marcado como pago!' : 'Marcado como pendente!');
      fetchData();
      setContaToPay(null);
    } catch {
      toast.error('Erro ao alterar status de pagamento.');
    }
  }, [contaToPay, fetchData]);

  const handleEdit = useCallback((conta) => {
    if (conta.isParcela) {
      setError('Edição não disponível para parcelas de pedidos.');
      return;
    }
    setCurrentConta(conta);
    setShowModal(true);
  }, []);

  const confirmDelete = useCallback((conta) => {
    if (conta.isParcela) {
      setError('Não é permitido excluir parcelas de pedidos.');
      return;
    }
    setContaToDelete(conta);
    setShowDeleteModal(true);
  }, []);

  const limparFiltros = () => {
    setSearchTerm(''); setFilterTipo('todos'); setFilterStatus('todos');
    setFilterCategoria('todas'); setTipoPeriodo('mes');
    setFilterMes(mesAtual); setFilterAno(String(anoAtual));
    setFilterDataInicio(''); setFilterDataFim('');
    setCampoData('dataVencimento');
  };

  // ── Filtro + Ordenação ──
  const filteredContas = useMemo(() => {
    let list = contas;

    if (filterTipo !== 'todos')      list = list.filter(c => c.tipo === filterTipo);
    if (filterStatus !== 'todos')    list = list.filter(c => c.status === filterStatus);
    if (filterCategoria !== 'todas') list = list.filter(c => c.categoria === filterCategoria);

    // 🆕 Filtro por período usando campo dinâmico (vencimento OU pagamento)
    if (tipoPeriodo === 'mes' && filterMes && filterAno) {
      list = list.filter(c => {
        const dataRef = c[campoData];
        if (!dataRef) return false;
        const d = new Date(dataRef);
        return d.getMonth() + 1 === parseInt(filterMes)
            && d.getFullYear() === parseInt(filterAno);
      });
    }
    if (tipoPeriodo === 'periodo') {
      if (filterDataInicio) {
        list = list.filter(c => c[campoData] && new Date(c[campoData]) >= new Date(filterDataInicio));
      }
      if (filterDataFim) {
        list = list.filter(c => c[campoData] && new Date(c[campoData]) <= new Date(filterDataFim));
      }
    }

    if (debouncedSearch.trim()) {
      const t = debouncedSearch.toLowerCase();
      list = list.filter(c =>
        (c.descricao   || '').toLowerCase().includes(t) ||
        (c.categoria   || '').toLowerCase().includes(t) ||
        (c.clienteNome || '').toLowerCase().includes(t)
      );
    }

    if (sortConfig.key) {
      list = [...list].sort((a, b) => {
        let av = a[sortConfig.key], bv = b[sortConfig.key];
        if (sortConfig.key === 'valor') { av = Number(av) || 0; bv = Number(bv) || 0; }
        if (['dataVencimento','dataPagamento'].includes(sortConfig.key)) {
          av = av ? new Date(av) : new Date(0);
          bv = bv ? new Date(bv) : new Date(0);
        }
        if (av < bv) return sortConfig.direction === 'asc' ? -1 : 1;
        if (av > bv) return sortConfig.direction === 'asc' ?  1 : -1;
        return 0;
      });
    }
    return list;
  }, [contas, filterTipo, filterStatus, filterCategoria, tipoPeriodo, filterMes, filterAno, filterDataInicio, filterDataFim, debouncedSearch, sortConfig, campoData]);

  // ── Totais ──
  const totals = useMemo(() => ({
    totalReceber:  filteredContas.filter(c => c.tipo === TIPOS.RECEBER && c.status !== STATUS.PAGO).reduce((s, c) => s + (c.valor || 0), 0),
    totalPagar:    filteredContas.filter(c => c.tipo === TIPOS.PAGAR   && c.status !== STATUS.PAGO).reduce((s, c) => s + (c.valor || 0), 0),
    totalAtrasado: filteredContas.filter(c => c.status === STATUS.ATRASADO).reduce((s, c) => s + (c.valor || 0), 0),
    totalPago:     filteredContas.filter(c => c.status === STATUS.PAGO).reduce((s, c) => s + (c.valor || 0), 0),
  }), [filteredContas]);

  const handleSort = (key) => setSortConfig(prev => ({
    key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
  }));

  const SortIcon = ({ col }) => {
    if (sortConfig.key !== col) return <FaSort className="ms-1 text-muted" />;
    return sortConfig.direction === 'asc' ? <FaSortUp className="ms-1" /> : <FaSortDown className="ms-1" />;
  };

  // ── Pílulas ──
  const StatusPilula = ({ status }) => {
    const map = {
      [STATUS.PAGO]:     { color: '#198754', text: 'Pago',     icon: FaCheck            },
      [STATUS.ATRASADO]: { color: '#dc3545', text: 'Atrasado', icon: FaExclamationTriangle },
      [STATUS.PENDENTE]: { color: '#f8961e', text: 'Pendente', icon: FaClock            },
    };
    const c = map[status] || map[STATUS.PENDENTE];
    return <Pilula color={c.color} icon={c.icon}>{c.text}</Pilula>;
  };

  const TipoPilula = ({ tipo }) => (
    tipo === TIPOS.RECEBER
      ? <Pilula color="#198754" icon={FaArrowDown}>A Receber</Pilula>
      : <Pilula color="#dc3545" icon={FaArrowUp}>A Pagar</Pilula>
  );

  const exportCSV = () => {
    const rows = [
      ['Descrição','Categoria','Tipo','Valor','Vencimento','Status','Pagamento','Cliente'].join(','),
      ...filteredContas.map(c => [
        `"${c.descricao}"`, `"${c.categoria}"`,
        c.tipo === TIPOS.RECEBER ? 'A Receber' : 'A Pagar',
        c.valor, formatDate(c.dataVencimento),
        c.status === STATUS.PAGO ? 'Pago' : c.status === STATUS.ATRASADO ? 'Atrasado' : 'Pendente',
        formatDate(c.dataPagamento), `"${c.clienteNome || '-'}"`
      ].join(','))
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([rows], { type: 'text/csv;charset=utf-8;' }));
    a.download = `contas_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  const labelPeriodo = useMemo(() => {
    const tipoLabel = campoData === 'dataVencimento' ? 'Vencimento' : 'Pagamento';

    if (tipoPeriodo === 'mes') {
      return `${tipoLabel}: ${MESES.find(m => m.value === filterMes)?.label || ''} / ${filterAno}`;
    }
    if (tipoPeriodo === 'periodo' && (filterDataInicio || filterDataFim)) {
      return `${tipoLabel}: ${filterDataInicio ? formatDate(filterDataInicio) : '...'} até ${filterDataFim ? formatDate(filterDataFim) : '...'}`;
    }
    return 'Todos os períodos';
  }, [tipoPeriodo, filterMes, filterAno, filterDataInicio, filterDataFim, campoData]);

  return (
    <Container fluid className="p-4">

      <PageHeader
        title="Contas a Pagar e Receber"
        subtitle={<><FaCalendarAlt className="me-1" />{labelPeriodo}</>}
        buttonLabel="Nova Conta"
        onButtonClick={() => { setCurrentConta(null); setShowModal(true); }}
      >
        <Button variant="outline-secondary" onClick={exportCSV} disabled={filteredContas.length === 0} className="me-2">
          <FaDownload className="me-2" />Exportar CSV
        </Button>
      </PageHeader>

      {error && <Alert variant="danger" dismissible onClose={() => setError('')}><FaExclamationTriangle className="me-2" />{error}</Alert>}

      {/* ── Cards KPI ── */}
      <Row className="mb-4">
        {[
          { label: 'A Receber',      value: totals.totalReceber,                        color: 'success', Icon: FaArrowDown   },
          { label: 'A Pagar',        value: totals.totalPagar,                          color: 'danger',  Icon: FaArrowUp     },
          { label: 'Em Atraso',      value: totals.totalAtrasado,                       color: 'warning', Icon: FaCalendarAlt },
          { label: 'Saldo Previsto', value: totals.totalReceber - totals.totalPagar,
            color: totals.totalReceber - totals.totalPagar >= 0 ? 'success' : 'danger', Icon: FaMoneyBillWave },
        ].map(({ label, value, color, Icon }) => (
          <Col lg={3} md={6} className="mb-3" key={label}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">{label}</div>
                  <h4 className={`mb-0 text-${color}`}>{formatCurrency(value)}</h4>
                </div>
                <div className={`bg-${color} bg-opacity-10 p-3 rounded-circle`}>
                  <Icon className={`text-${color}`} size={20} />
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* ── Filtros ── */}
      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
          <span className="fw-semibold"><FaFilter className="me-2" />Filtros</span>
          <Button variant="link" size="sm" className="text-muted p-0 text-decoration-none" onClick={limparFiltros}>
            <FaTimes className="me-1" />Limpar filtros
          </Button>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3 g-2">
            <Col lg={4}>
              <InputGroup>
                <InputGroup.Text><FaSearch /></InputGroup.Text>
                <Form.Control placeholder="Buscar por descrição, categoria ou cliente..."
                  value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
              </InputGroup>
            </Col>
            <Col lg={2} md={4}>
              <Form.Select value={filterTipo} onChange={e => setFilterTipo(e.target.value)}>
                <option value="todos">Todos os Tipos</option>
                <option value={TIPOS.RECEBER}>A Receber</option>
                <option value={TIPOS.PAGAR}>A Pagar</option>
              </Form.Select>
            </Col>
            <Col lg={2} md={4}>
              <Form.Select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                <option value="todos">Todos os Status</option>
                <option value={STATUS.PENDENTE}>Pendente</option>
                <option value={STATUS.PAGO}>Pago</option>
                <option value={STATUS.ATRASADO}>Atrasado</option>
              </Form.Select>
            </Col>
            <Col lg={4} md={4}>
              <Form.Select value={filterCategoria} onChange={e => setFilterCategoria(e.target.value)}>
                <option value="todas">Todas as Categorias</option>
                {categoriasUnicas.map(c => <option key={c} value={c}>{c}</option>)}
              </Form.Select>
            </Col>
          </Row>

          <Row className="align-items-end g-2">
            {/* 🆕 Seletor: filtrar por Vencimento OU Pagamento */}
            <Col lg={3} md={6}>
              <Form.Label className="small text-muted mb-1">Filtrar pela data de</Form.Label>
              <div className="d-flex gap-1">
                <Button
                  size="sm"
                  className="flex-fill"
                  variant={campoData === 'dataVencimento' ? 'primary' : 'outline-secondary'}
                  onClick={() => setCampoData('dataVencimento')}
                >
                  <FaCalendarAlt className="me-1" size={10} />
                  Vencimento
                </Button>
                <Button
                  size="sm"
                  className="flex-fill"
                  variant={campoData === 'dataPagamento' ? 'primary' : 'outline-secondary'}
                  onClick={() => setCampoData('dataPagamento')}
                >
                  <FaCheck className="me-1" size={10} />
                  Pagamento
                </Button>
              </div>
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className="small text-muted mb-1">Filtrar por período</Form.Label>
              <div className="d-flex gap-1">
                {[{ value:'mes',label:'Mês/Ano'},{value:'periodo',label:'Intervalo'},{value:'todos',label:'Todos'}].map(op => (
                  <Button key={op.value} size="sm" className="flex-fill"
                    variant={tipoPeriodo === op.value ? 'primary' : 'outline-secondary'}
                    onClick={() => setTipoPeriodo(op.value)}>
                    {op.label}
                  </Button>
                ))}
              </div>
            </Col>

            {tipoPeriodo === 'mes' && <>
              <Col lg={2} md={6}>
                <Form.Label className="small text-muted mb-1">Mês</Form.Label>
                <Form.Select value={filterMes} onChange={e => setFilterMes(e.target.value)}>
                  {MESES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                </Form.Select>
              </Col>
              <Col lg={2} md={6}>
                <Form.Label className="small text-muted mb-1">Ano</Form.Label>
                <Form.Select value={filterAno} onChange={e => setFilterAno(e.target.value)}>
                  {gerarAnos().map(a => <option key={a} value={String(a)}>{a}</option>)}
                </Form.Select>
              </Col>
            </>}
            {tipoPeriodo === 'periodo' && <>
              <Col lg={2} md={6}>
                <Form.Label className="small text-muted mb-1">Data Início</Form.Label>
                <Form.Control type="date" value={filterDataInicio} onChange={e => setFilterDataInicio(e.target.value)} />
              </Col>
              <Col lg={2} md={6}>
                <Form.Label className="small text-muted mb-1">Data Fim</Form.Label>
                <Form.Control type="date" value={filterDataFim} min={filterDataInicio} onChange={e => setFilterDataFim(e.target.value)} />
              </Col>
            </>}
          </Row>

          {/* 💡 Dica visual quando filtra por pagamento */}
          {campoData === 'dataPagamento' && (
            <Alert variant="info" className="mt-3 mb-0 py-2 small">
              <FaCheck className="me-2" />
              Mostrando apenas contas <strong>com data de pagamento</strong> no período selecionado.
              Útil para conferir lançamentos pagos.
            </Alert>
          )}
        </Card.Body>
      </Card>

      {/* ── Tabela ── */}
      {loading ? (
        <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>
      ) : (
        <Card className="shadow-sm">
          <Card.Body>
            <p className="text-muted mb-3">
              {filteredContas.length} conta(s) — {labelPeriodo}
              {totals.totalPago > 0 && (
                <span className="ms-2">
                  • <strong className="text-success">Pago: {formatCurrency(totals.totalPago)}</strong>
                </span>
              )}
            </p>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    {[
                      ['descricao','Descrição'],['categoria','Categoria'],['tipo','Tipo'],
                      ['valor','Valor'],['dataVencimento','Vencimento'],
                      ['dataPagamento','Pagamento'],
                      ['status','Status'],['clienteNome','Cliente'],
                    ].map(([key, label]) => (
                      <th key={key} style={{ cursor:'pointer' }} onClick={() => handleSort(key)}>
                        {label} <SortIcon col={key} />
                      </th>
                    ))}
                    <th className="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredContas.map(conta => (
                    <tr key={conta.id}>
                      <td>
                        {conta.descricao}
                        {conta.isParcela && <><br /><small className="text-muted">Parcela de pedido</small></>}
                      </td>
                      <td>{conta.categoria}</td>
                      <td><TipoPilula tipo={conta.tipo} /></td>
                      <td className="fw-bold">{formatCurrency(conta.valor)}</td>
                      <td>{formatDate(conta.dataVencimento)}</td>
                      <td>
                        {conta.dataPagamento
                          ? <small className="text-success">{formatDate(conta.dataPagamento)}</small>
                          : <small className="text-muted">-</small>}
                      </td>
                      <td><StatusPilula status={conta.status} /></td>
                      <td>{conta.clienteNome || '-'}</td>
                      <td className="text-end">
                        <div className="d-flex justify-content-end gap-1">
                          <OverlayTrigger placement="top" overlay={<Tooltip>{conta.status === STATUS.PAGO ? 'Marcar pendente' : 'Marcar pago'}</Tooltip>}>
                            <Button size="sm"
                              variant={conta.status === STATUS.PAGO ? 'outline-warning' : 'outline-success'}
                              onClick={() => { setContaToPay(conta); setShowPayModal(true); }}>
                              {conta.status === STATUS.PAGO ? <FaUndo /> : <FaCheck />}
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{conta.isParcela ? 'Não editável' : 'Editar'}</Tooltip>}>
                            <span className="d-inline-block">
                              <Button size="sm" variant="outline-primary"
                                onClick={() => handleEdit(conta)} disabled={conta.isParcela}>
                                <FaEdit />
                              </Button>
                            </span>
                          </OverlayTrigger>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{conta.isParcela ? 'Não excluível' : 'Excluir'}</Tooltip>}>
                            <span className="d-inline-block">
                              <Button size="sm" variant="outline-danger"
                                onClick={() => confirmDelete(conta)} disabled={conta.isParcela}>
                                <FaTrash />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredContas.length === 0 && (
                    <tr>
                      <td colSpan={9} className="text-center py-5">
                        <FaEye size={40} className="mb-2 opacity-25 d-block mx-auto" />
                        <p className="text-muted mb-0">Nenhuma conta encontrada</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* ── Modal Novo/Editar ── */}
      <Modal show={showModal} onHide={() => { setShowModal(false); setCurrentConta(null); }} size="lg">
        <Modal.Body className="p-0">
          <ContaForm conta={currentConta} onSave={handleSave}
            onCancel={() => { setShowModal(false); setCurrentConta(null); }} />
        </Modal.Body>
      </Modal>

      {/* ── Modal Pagamento ── */}
      <ConfirmModal
        show={showPayModal}
        onHide={() => setShowPayModal(false)}
        onConfirm={() => handleTogglePay(contaToPay?.status !== STATUS.PAGO)}
        title="Confirmar Alteração"
        message={<>Deseja alterar o status de: <strong>"{contaToPay?.descricao}"</strong>?</>}
        confirmLabel={contaToPay?.status === STATUS.PAGO ? 'Marcar como Pendente' : 'Marcar como Pago'}
        confirmVariant={contaToPay?.status === STATUS.PAGO ? 'warning' : 'success'}
        icon={FaClock}
        iconColor="text-primary"
      />

      {/* ── Modal Exclusão ── */}
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
        title="Confirmar Exclusão"
        message={<>Tem certeza que deseja excluir: <strong>"{contaToDelete?.descricao}"</strong>?</>}
        confirmLabel="Excluir"
        confirmVariant="danger"
      />

    </Container>
  );
}

// ==========================================
// FORMULÁRIO
// ==========================================
function ContaForm({ conta, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    id:             conta?.id             || null,
    tipo:           conta?.tipo           || TIPOS.PAGAR,
    descricao:      conta?.descricao      || '',
    valor:          conta?.valor          || '',
    dataVencimento: conta?.dataVencimento ? conta.dataVencimento.split('T')[0] : '',
    dataPagamento:  conta?.dataPagamento  ? conta.dataPagamento.split('T')[0]  : '',
    status:         conta?.status         || STATUS.PENDENTE,
    categoria:      conta?.categoria      || '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const isPagar = formData.tipo === TIPOS.PAGAR;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.descricao.trim() || !formData.valor) return;
    setIsSubmitting(true);
    await onSave(formData);
    setIsSubmitting(false);
  };

  return (
    <Card className="border-0 mb-0">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center py-3">
        <h5 className="mb-0">{conta ? 'Editar Conta' : 'Nova Conta'}</h5>

        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant={isPagar ? 'danger' : 'outline-danger'}
            onClick={() => setFormData(prev => ({ ...prev, tipo: TIPOS.PAGAR }))}
          >
            <FaArrowUp className="me-1" size={10} />
            A Pagar
          </Button>
          <Button
            size="sm"
            variant={!isPagar ? 'success' : 'outline-success'}
            onClick={() => setFormData(prev => ({ ...prev, tipo: TIPOS.RECEBER }))}
          >
            <FaArrowDown className="me-1" size={10} />
            A Receber
          </Button>
        </div>
      </Card.Header>

      <Card.Body className="p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Descrição *</Form.Label>
                <Form.Control name="descricao" value={formData.descricao} onChange={handleChange} required
                  placeholder="Ex: Pagamento de aluguel..." />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Categoria *</Form.Label>
                <Form.Control name="categoria" value={formData.categoria} onChange={handleChange} required
                  placeholder="Ex: Aluguel, Impostos..." />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Valor *</Form.Label>
                <InputGroup>
                  <InputGroup.Text>R$</InputGroup.Text>
                  <Form.Control type="number" name="valor" value={formData.valor}
                    onChange={handleChange} required min="0.01" step="0.01" placeholder="0,00" />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Data de Vencimento *</Form.Label>
                <Form.Control type="date" name="dataVencimento" value={formData.dataVencimento}
                  onChange={handleChange} required />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <div className="d-flex align-items-center gap-2 mt-1">
                  <StatusSwitch
                    value={formData.status === STATUS.PAGO}
                    onChange={(v) => setFormData(prev => ({
                      ...prev,
                      status: v ? STATUS.PAGO : STATUS.PENDENTE,
                      dataPagamento: v ? new Date().toISOString().split('T')[0] : '',
                    }))}
                    labelOn="Pago"
                    labelOff="Pendente"
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>

          {formData.status === STATUS.PAGO && (
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Data de Pagamento *</Form.Label>
                  <Form.Control type="date" name="dataPagamento" value={formData.dataPagamento}
                    onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>
          )}

          <hr />
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
              <FaTimes className="me-1" />Cancelar
            </Button>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting ? <Spinner animation="border" size="sm" /> : <><FaSave className="me-2" />Salvar</>}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
